export default __webpack_public_path__ + "static/professional_sectionbg-4237a3d184fb5bc5215c7ac77d5f08e3.png";